export const SET_ROLE_LIST = "SET_ROLE_LIST";
export const SET_ROLE_TABLE_LOADING = "SET_ROLE_TABLE_LOADING";
export const SET_ROLE_GET_BY_ID = "SET_ROLE_GET_BY_ID";
